export default __webpack_public_path__ + "static/media/026-Quran.15c4a64f.svg";